export default __webpack_public_path__ + "static/media/taxTypeImg.06b3e6f4.svg";